// extracted by mini-css-extract-plugin
export default {"actionBtn":"DeactivateButton_actionBtn__4fbVx","text":"DeactivateButton_text__xyV-p"};